import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	border-top: 1px dashed ${colors.grey4};
	border-radius: 1px;
`;
